export default "__VITE_ASSET__0ZYyk802__"